import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { TooltipProps } from "./Tooltip.types";

export const useTooltipStyles = makeStyles((theme) => ({
  arrow: (props: TooltipProps) => ({
    color: getColor(theme, props.color),
    "&::before": {
      border:
        props.color !== "green" && props.color !== "black"
          ? `2px solid ${theme.palette.grey[200]}`
          : undefined,
    },
  }),
  tooltip: (props: TooltipProps) => ({
    padding: 16,
    backgroundColor: getColor(theme, props.color),
    color: getTextColor(theme, props.color),
    boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.2)",
    fontSize: 14,
    lineHeight: "18px",
    width: props.width,
    maxWidth: props.maxWidth,
  }),
}));

export const useStyles = makeStyles((theme) => ({
  infoIcon: (props: TooltipProps) => ({
    display: "block",
    width: 20,
    height: 20,
    marginBottom: 8,
    color: getTextColor(theme, props.color),
  }),
  action: {
    marginTop: 8,
  },
}));

function getColor(theme: Theme, color: TooltipProps["color"]) {
  if (color === "green") {
    return theme.palette.primary.main;
  } else if (color === "black") {
    return theme.palette.common.black;
  }
  return theme.palette.common.white;
}

function getTextColor(theme: Theme, color: TooltipProps["color"]) {
  if (color === "green" || color === "black") {
    return theme.palette.common.white;
  }
  return theme.palette.grey[900];
}
